import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleSpinner } from 'apps/auth/actions/appAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { CHANGE_RESIDENCE_ADDRESS_CLICKED, RESIDENCY_ADDRESS_UNSUPPORTED_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const ResidenceAddressUpdatePopup = ({ popupRef, toggleSpinner }) => {
    useEffect(() => {
        amplitude.getInstance().logEvent(RESIDENCY_ADDRESS_UNSUPPORTED_SHOWN);
    }, []);

    const { gotIt, changeResidenceButton, changeResidenceText } = usePageMessages();

    const handleClose = (e) => {
        e?.preventDefault();
        popupRef?.current?.close();
    };

    return (
        <SimplePopup withoutBorder popupRef={popupRef} text={<DangerouslyHtml dangerouslyHtml={changeResidenceText} />}>
            <PopupButton
                text={changeResidenceButton}
                iconName="pencil"
                href={'/auth/profile/additional/fields/screen'}
                onClick={() => {
                    amplitude.getInstance().logEvent(CHANGE_RESIDENCE_ADDRESS_CLICKED);
                    toggleSpinner(true);
                    popupRef?.current?.close();
                }}
            />
            <PopupButton text={gotIt} iconName="check" onClick={handleClose} />
        </SimplePopup>
    );
};

ResidenceAddressUpdatePopup.propTypes = {
    popupRef: PropTypes.object.isRequired,
    toggleSpinner: PropTypes.func.isRequired,
};

export default connect(null, { toggleSpinner })(ResidenceAddressUpdatePopup);
